const PsalterWeeks = {
  "1": "Week I",
  "2": "Week II",
  "3": "Week III",
  "4": "Week IV",
  "5": "Easter"
};
export default PsalterWeeks;